module.exports = __webpack_public_path__ + "static/media/AxReg_icon.efee6d42.svg";